import React from "react";
import { Observer } from "mobx-react";
import { toASCII } from "@bonliva-crm/common";
import { hasClassInParent } from "@bonliva-crm/ui";
import { ClickAwayListener, Paper, Popover } from "@material-ui/core";
import { ConsultantQualityItemEditor } from "../quality-item-editor/ConsultantQualityItemEditor";
import { HealthDeclarationQualityItemEditor } from "../quality-check/health-declaration-quality-check";
import { hlrNames } from "../quality-check/hlr-quality-check/hlr-quality-check";
import { HlrQualityCheckItemEditor } from "../quality-check/hlr-quality-check/hlr-quality-check-item-editor";
import { QualityChecksStore } from "../../quality-checks-store";
import { HSAIDQualityItemEditor } from "../quality-check/hsaid-quality-check/hsaid-quality-item-editor";

type QualityCheckEditorProps = {
  store: QualityChecksStore;
};

export default function QualityCheckEditor({ store }: QualityCheckEditorProps) {
  const id = toASCII(
    `quality_check_${store.activeQualityCheck.country}_${store.activeQualityCheck.name}_${
      store.activeQualityCheck.isNationalReference ? "national" : "non_national"
    }`
  );

  const renderQualityItemForm = (name: string) => {
    const ivoGrundSetOn = store.consultant.QualityPerCountry.find(
      (x) => x.Country === "Sweden"
    )?.QualityChecks.find((x) => x.Name === "IVO-Grund")?.StatusSetOn;

    if (hlrNames.includes(name)) {
      return (
        <HlrQualityCheckItemEditor
          consultantId={store.consultantId}
          country={store.activeQualityCheck.country}
          itemName={store.activeQualityCheck.name}
          itemType={store.activeQualityCheck.type}
          onClose={store.closeQualityControlEditor}
        />
      );
    }

    switch (name) {
      case "Hälsodeklaration":
        return (
          <HealthDeclarationQualityItemEditor
            consultantId={store.consultantId}
            country={store.activeQualityCheck.country}
            itemName={store.activeQualityCheck.name}
            itemType={store.activeQualityCheck.type}
            onClose={store.closeQualityControlEditor}
          />
        );
      case "HSAID/SITHS":
        return (
          <HSAIDQualityItemEditor
            consultantId={store.consultantId}
            country={store.activeQualityCheck.country}
            itemName={store.activeQualityCheck.name}
            itemType={store.activeQualityCheck.type}
            onClose={store.closeQualityControlEditor}
          />
        );
      default:
        return (
          <ConsultantQualityItemEditor
            consultantId={store.consultantId}
            country={store.activeQualityCheck.country}
            itemName={store.activeQualityCheck.name}
            itemType={store.activeQualityCheck.type}
            referenceId={store.activeQualityCheck.referenceId}
            isNationalReference={store.activeQualityCheck.isNationalReference}
            onClose={store.closeQualityControlEditor}
            ivoGrundSetOn={ivoGrundSetOn}
            templateName={store.activeQualityCheck.templateName}
          />
        );
    }
  };

  return (
    <Observer>
      {() => (
        <Popover
          open={true}
          anchorEl={() => document.querySelector(`#${id}`)}
          transformOrigin={{
            horizontal: "right",
            vertical: "center"
          }}
          keepMounted={false}
          disablePortal
          style={{ /* zIndex: 9999 */ overflow: "visible" }}
        >
          <ClickAwayListener
            onClickAway={(e) => {
              const dontCloseIfParents = [
                "react-datepicker",
                "dropdown-button-menu",
                "document-uploader",
                "dnd-input" // see UploadStore::requestUpload
              ];

              if (hasClassInParent(e.target, dontCloseIfParents)) {
                return;
              }

              store.closeQualityControlEditor();
            }}
          >
            <Paper>{renderQualityItemForm(store.activeQualityCheck.name)}</Paper>
          </ClickAwayListener>
        </Popover>
      )}
    </Observer>
  );
}
